<template>
  <div class="swiper-slide">
    <slot></slot>
  </div>
</template>
<script>
export default {}
</script>
<style lang="stylus" scoped>
.swiper-slide
  position relative
</style>



// WEBPACK FOOTER //
// swiper-item.vue?1e016d8e